<p class="tooltip-list-title">Password must:</p>
<ul class="password-requirement-list">
  <li *ngFor="let requirement of passwordRequirements;">
    {{requirement}}
  </li>
</ul>